<template>
    <div class="logreg-header clearfix">
        <div class="header-left">
            <div class="logo" title="商维宝">
                <img v-resc-url="'/app/image/logo/plat-logo.png'"/>
            </div>
            <a class="font-gold ml15 mt30 font24 fl">{{item.name}}</a>
        </div>
        <div v-if="item.type == 'regist' || item.type == 'reset'" class="header-right">
            <b class="ml15 fl font-gray2 font16" style="margin-top: 40px;">已有账号？
            <a v-app-url="'/user/login/jsp'" class="font-gray4">请登录</a></b>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Routes } from '../../app.vues'
    export default {
        name: 'swb-login-head',
        desc: '',
        props: ['item'],
        data: function () {
            return {}
        },
        mounted: function () {
        },
        methods: {}
    }

</script>





// WEBPACK FOOTER //
// src/compo/user/Login-head.vue